export default __webpack_public_path__ + "static/4-37a9658af999ddf5911c34532d0ff9b8.jpg";